import {Checkbox, Label, Pane, Table} from "evergreen-ui";
import React from "react";
import {useDispatch} from "react-redux";

export default function OperationsComponent({
    disabled,
    operations,
    columns,
    columnsOnSelectActions,
    columnsOnDeselectActions,
    selectedOperationsForColumns
}) {

    const dispatch = useDispatch();

    function checkIfChecked(columnIndex, rowIndex) {
        const op = operations[rowIndex]
        return selectedOperationsForColumns[columnIndex].map(operation => operation.code).includes(op.code)
    }

    function getOperation(rowIndex) {
        return operations[rowIndex]
    }

    function doCheckAction(columnIndex, rowIndex, checked) {
        if (checked) {
            const operation = getOperation(rowIndex)
            dispatch(columnsOnSelectActions[columnIndex](operation))
        } else {
            const operation = getOperation(rowIndex)
            dispatch(columnsOnDeselectActions[columnIndex](operation.code))
        }
    }



    return <Pane>
        <Label>Выберите операции</Label>
        <Pane marginTop={4}>
            <Table.Head height={50}>
                <Table.TextHeaderCell>Операции</Table.TextHeaderCell>
                {
                    columns.map((el) => <Table.TextHeaderCell textAlign={"center"}>
                        {el}
                    </Table.TextHeaderCell>)
                }
            </Table.Head>
            <Table.Body>
                {operations.map((op, rowIndex) =>
                    <Table.Row key={1} >
                        <Table.TextHeaderCell>{op.name}</Table.TextHeaderCell>
                        {
                            columns.map((el, columnIndex) => <Table.Cell width={130}>
                                    <Checkbox marginLeft={"auto"}
                                              marginRight={"auto"}
                                              disabled={disabled}
                                              onChange={(e) => doCheckAction(columnIndex, rowIndex, e.target.checked)}
                                              checked={checkIfChecked(columnIndex, rowIndex)}/>
                                </Table.Cell>
                            )
                        }
                    </Table.Row>)
                }
            </Table.Body>
        </Pane>
    </Pane>

}